// @flow
export const createAddressString = ({
  apt,
  city,
  state,
  street,
  zipCode,
}: {
  city: string,
  state: string,
  street: string,
  zipCode: string,
  apt?: string,
}) => `${street}${apt ? ` Apt. ${apt}` : ''}, ${city}, ${state} ${zipCode}`;
